var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F970(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 24,
    fill: "#FCEA2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA7C0",
    d: "M11.319 34.66a.351.351 0 01-.633 0 4.048 4.048 0 10-6.917 4.143l7.233 9.274 7.191-9.218.232-.342a4.048 4.048 0 10-7.106-3.857zM48.319 7.66a.351.351 0 01-.633 0 4.048 4.048 0 10-6.917 4.143l7.233 9.274 7.191-9.218.232-.342A4.048 4.048 0 1048.32 7.66zM56.319 52.66a.351.351 0 01-.633 0 4.048 4.048 0 10-6.917 4.143l7.233 9.274 7.191-9.218.232-.342a4.048 4.048 0 10-7.106-3.857z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M45.815 44.804a15.43 15.43 0 01-19.63 0M52.04 50.366a4.05 4.05 0 00-3.462 6.15l.232.343 7.191 9.218 7.233-9.275a4.048 4.048 0 10-6.916-4.142.351.351 0 01-.633 0 4.021 4.021 0 00-3.645-2.294zM7.04 32.366a4.05 4.05 0 00-3.462 6.15l.232.343 7.191 9.218 7.233-9.275a4.048 4.048 0 10-6.916-4.142.351.351 0 01-.633 0 4.021 4.021 0 00-3.645-2.294zM44.04 5.366a4.05 4.05 0 00-3.462 6.15l.232.343 7.191 9.218 7.233-9.275a4.048 4.048 0 10-6.916-4.142.351.351 0 01-.633 0 4.021 4.021 0 00-3.645-2.294zM42.808 57.976A22.993 22.993 0 0136 59c-7.94 0-14.939-4.022-19.072-10.14M53.748 21.37A22.905 22.905 0 0159 36c0 3.603-.829 7.013-2.306 10.05M14.732 27.227C18.181 18.877 26.404 13 36 13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M31.694 32.404a4.726 4.726 0 00-8.638 0M48.944 32.404a4.726 4.726 0 00-8.638 0"
  }))));
}
export default Svg1F970;